import { useState } from 'react';
import { eventService } from 'services/api';
import AvisoModal from 'components/AvisoModal';
import SearchableSelect from 'components/SearchableSelect';
import styles from './EventModal.module.css';

export default function EventModal({ editing, companies, onClose, onSaved }) {
  const [form, setForm] = useState({
    company_id: '', name: '', description: '', address: '',
    start_time: '', end_time: '', duration_days: 1,
    ...(editing ? {
      ...editing,
      start_time: editing.start_time ? new Date(editing.start_time).toISOString().slice(0,16) : '',
      end_time:   editing.end_time   ? new Date(editing.end_time).toISOString().slice(0,16)   : '',
    } : {}),
  });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState('');
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    if (!form.company_id) return setError('Selecciona una compañía');
    if (!form.name.trim()) return setError('El nombre del evento es requerido');
    if (!form.start_time) return setError('La fecha y hora de inicio es requerida');
    if (!form.end_time)   return setError('La fecha y hora de fin es requerida');
    if (new Date(form.end_time) <= new Date(form.start_time))
      return setError('La fecha y hora de fin debe ser posterior a la de inicio');
    setSaving(true); setError('');
    try {
      if (editing) await eventService.update(editing.id, form);
      else         await eventService.create(form);
      onSaved(editing ? 'Evento actualizado' : 'Evento creado');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar');
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.modalEvento}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className={`fas fa-ticket ${styles.iconoTitulo}`} />
            {editing ? 'Editar evento' : 'Nuevo evento'}
          </h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={save} noValidate>
          <div className={`modal-body ${styles.cuerpo}`}>
            {error && <AvisoModal>{error}</AvisoModal>}

            {/* Compañía — primer campo obligatorio */}
            <div className="form-group">
              <label className="form-label">Compañía *</label>
              <SearchableSelect value={form.company_id} onChange={(id) => set('company_id', id)} placeholder="— Selecciona una compañía —" allowEmpty={false} minWidth={0} maxWidth={9999} ariaLabel="Compañía"
                options={companies.map(c => ({ value: c.id, label: c.name }))} />
            </div>

            <div className="form-group">
              <label className="form-label">Nombre del evento *</label>
              <input className="form-control" value={form.name} onChange={e => set('name', e.target.value)} required maxLength={200} placeholder="Nombre del evento" />
            </div>

            <div className="form-group">
              <label className="form-label">Descripción</label>
              <textarea className="form-control" rows={3} value={form.description} onChange={e => set('description', e.target.value)} maxLength={5000} placeholder="Descripción del evento..." />
            </div>

            <div className="form-group">
              <label className="form-label">Lugar / Dirección</label>
              <input className="form-control" value={form.address} onChange={e => set('address', e.target.value)} maxLength={255} placeholder="Lugar o dirección del evento" />
            </div>

            <div className={styles.rejilla}>
              <div className="form-group">
                <label className="form-label">Fecha y hora inicio *</label>
                <input type="datetime-local" className="form-control" value={form.start_time} onChange={e => set('start_time', e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Fecha y hora fin *</label>
                <input type="datetime-local" className="form-control" value={form.end_time}
                  onChange={e => set('end_time', e.target.value)} required />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Duración (días)</label>
              <input type="number" min={1} max={30} className={`form-control ${styles.campoDias}`}
                value={form.duration_days} onChange={e => set('duration_days', e.target.value)} />
              <small className={styles.nota}>
                Para eventos de varios días — permite llevar el registro de asistencia día por día.
              </small>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? <><i className="fas fa-spinner fa-spin" /> Guardando...</> : <><i className="fas fa-save" /> Guardar</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
